import gql from 'graphql-tag'

const deleteMicrositeInvitationMutation = gql`
  mutation deleteMicrositeInvitation($id: String!) {
    deleteMicrositeInvitation(id: $id)
  }
`

export default deleteMicrositeInvitationMutation
